import { FlagshipProvider } from './FlagshipContext'

export * from './FlagshipContext'
export * from '@flagship.io/js-sdk'
export * from './FlagshipHooks'

export default FlagshipProvider
